"use client";
import { useEffect, useState } from "react";
import { toast_configs } from "@core/constants/toast_configs";
import { Heart } from "lucide-react"
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import { openAuthModal } from "@/hooks/useAuthModal";
import { show_mutation_error_toast } from "@core/helpers/mutation-errors";
import LoadingSpinner from "@/components/LoadingSpinner";
;
const LIkeButtonProduct = ({
    data,
    is_favorite: isLiked,
    add_to_favorite_loading,
    add_product_to_favorites_handler,
    className = "",
}) => {

    const { is_auth } = useAuthContext();
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        setAnimate(true);

        const timeId = setTimeout(() => setAnimate(false), 200);

        return () => {
            clearTimeout(timeId);
        };
    }, [data?.is_favorite]);

    const add_to_favorites = (e) => {
        // کاربر مهمان: به جای پیام خطا، صفحه‌ی ورود نمایش داده می‌شود
        if (!is_auth) {
            e?.preventDefault?.();
            return openAuthModal();
        }

        return add_product_to_favorites_handler(e, {
            success_callback: (data) => {
                if (data?.is_favorite) {
                    toast_configs("به علاقه مندی ها اضافه شد", "success", {
                        className: "custome_toastify",
                        position: "bottom-center",
                        autoClose: 2000,
                    });
                }
            },
            error_callback: (errors) => {
                show_mutation_error_toast(errors);
                openAuthModal();
            },
        });
    };

    return (
        <>
            <button className={`cursor-pointer text-jmt-neutral-800 ${className}`}
                onClick={add_to_favorites}
                aria-label="پسندیدن">

                {add_to_favorite_loading ? (
                    <LoadingSpinner size={18} />
                ) : (
                    <Heart className={`w-4.5 h-4.5 lg:w-5.5 lg:h-5.5 transition-all duration-200
            ${isLiked ? "fill-jmt-main text-jmt-main" : "text-jmt-neutral-800"}
            ${animate ? "scale-pop" : ""}`}
                    />)}

            </button>

            {/*  Scale */}
            <style>
                {`
        .scale-pop {
          animation: pop 0.2s ease-out forwards;
        }

        @keyframes pop {
          0% { transform: scale(1); }
          40% { transform: scale(1.35); }
          70% { transform: scale(0.9); }
          100% { transform: scale(1); }
        }
        `}
            </style>
        </>
    );
};

export default LIkeButtonProduct;
